import router from "@/router";

router.addRoute({
    path: "/hotel/sadmin/toggles",
    name: "Toggles",
    component: () => import("./View.vue"),
});
